import { ModalImage2 } from "./ModalImage2"

export const ModalWeedingPassImage = ({ id, code, isOpen, setIsOpen }) => {
  const imageUri = process.env.REACT_APP_URL_WEEDING_PASS_IMAGES + "?id=" + id + "&code=" + code

  return (
    <ModalImage2 imageUri = {imageUri} isOpen={isOpen} setIsOpen={setIsOpen}/>
  )
}
